import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { deleteSpace, fetchSpaces, updateSpace } from './Spaces.actions';
import { Action } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import SpaceService from '../../service/Space.service';
import {
  addSpaces,
  setListSpaces,
  setPage,
  setTotal,
  setIsFetching,
  updateSpaceById,
  setActiveSpace,
  setShowSpaceDetails,
  deleteSpaces,
} from './Spaces.slice';
import { Account, Unwrap } from '../../domains/app';
import { Space } from './spaces';
import { setSelectedAccount } from '../App/App.slice';

function* fetchSpacesSaga(action: Action) {
  try {
    yield put(setIsFetching(true));
    if (fetchSpaces.match(action)) {
      const refreshList = action.payload;
      if (refreshList) {
        yield put(setPage(0));
      }
      const page: number = yield select(
        (state: RootState) => state.spaces.page,
      );
      const pageSize: number = yield select(
        (state: RootState) => state.spaces.pageSize,
      );
      const search: string = yield select(
        (state: RootState) => state.spaces.search,
      );

      const res: Unwrap<ReturnType<
        typeof SpaceService.fetchListSpaces
      >> = yield call(SpaceService.fetchListSpaces, pageSize, page, search);
      if (refreshList) {
        yield put(setListSpaces([]));
      }
      yield put(addSpaces(res.items));
      yield put(setTotal(res.total));
      yield put(setPage(page + 1));
    }
  } catch (e) {
    console.error(e);
  } finally {
    yield put(setIsFetching(false));
  }
}

function* updateSpaceSaga(action: Action) {
  try {
    if (updateSpace.match(action)) {
      const { id, ownerId, name } = action.payload;
      const activeSpace: Space | undefined = yield select(
        (state: RootState) => state.spaces.activeSpace,
      );
      if (activeSpace && id) {
        if (name !== activeSpace.name) {
          yield call(
            SpaceService.updateSpaceName,
            id as string,
            name as string,
          );

          yield put(updateSpaceById({ id, name }));

          let selectedAccount: Account = yield select(
            (state: RootState) => state.app.selectedAccount,
          );
          if (selectedAccount.id === id) {
            yield put(
              setSelectedAccount({ ...selectedAccount, name: name as string }),
            );
          }
        }

        if (ownerId !== activeSpace.ownerId) {
          const res: Unwrap<ReturnType<
            typeof SpaceService.changeOwner
          >> = yield call(
            SpaceService.changeOwner,
            id as string,
            activeSpace.ownerId as string,
            ownerId as string,
          );

          yield put(
            updateSpaceById({ id, ownerId: res.ownerId, owner: res.owner }),
          );
        }
      }

      yield put(setActiveSpace());
      yield put(setShowSpaceDetails(false));
    }
  } catch (e) {
    console.error(e);
  } finally {
  }
}

function* deleteSpaceSaga(action: Action) {
  try {
    if (deleteSpace.match(action)) {
      const id = action.payload;

      yield call(SpaceService.deleteSpace, id);

      yield put(deleteSpaces(id));
      yield put(setActiveSpace());
      yield put(setShowSpaceDetails(false));

      const selectedAccount: Account = yield select(
        (state: RootState) => state.app.selectedAccount,
      );

      if (selectedAccount.id === id) {
        yield put(setSelectedAccount());
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([
    takeLatest(fetchSpaces.toString(), fetchSpacesSaga),
    takeLatest(updateSpace.toString(), updateSpaceSaga),
    takeLatest(deleteSpace.toString(), deleteSpaceSaga),
  ]);
}
